module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('p', [_vm._v("成都市高新区科园二路一号201室 028-85192910 028-66052899 13880586898（范小林）18980535778(李)")]), _vm._v(" "), _c('p', [_vm._v("copyright © 2013 成都利马高科有限公司 川ICP备09000473号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4114cd08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tempControl/pageFooter.vue
// module id = 912
// module chunks = 1